import { LocationPersonaControlViewState } from 'owa-location-persona';
import owaCalendarStrings from 'owa-strings/owa-calendar-strings';
import { format } from 'owa-strings';

export default function getAvailabilityTextAndStyle(
    locationResult: LocationPersonaControlViewState,
    styles: any
): any {
    let freebusyStyle = styles.availabilityUnknown;
    let freebusyText = owaCalendarStrings.unknownFreeBusy;

    if (locationResult.availability) {
        switch (locationResult.availability) {
            case 'Free':
                freebusyText = owaCalendarStrings.availableFreeBusy;
                freebusyStyle = styles.availabilityFree;
                break;
            case 'Busy':
                freebusyText = owaCalendarStrings.showAsBusy;
                freebusyStyle = styles.availabilityBusy;
                break;
        }
    }

    if (locationResult.totalNumberOfTimeSlots) {
        if (locationResult.totalNumberOfTimeSlots - locationResult.numberOfAvailableTimeSlots > 2) {
            freebusyText = owaCalendarStrings.locationSuggestionNotAvailable;
            freebusyStyle = styles.availabilityBusy;
        } else if (
            locationResult.numberOfAvailableTimeSlots == locationResult.totalNumberOfTimeSlots &&
            !locationResult.isPartialAvailability
        ) {
            freebusyText = owaCalendarStrings.availableFreeBusy;
            freebusyStyle = styles.availabilityFree;
        } else {
            const availabilityStringFormat = locationResult.isPartialAvailability
                ? owaCalendarStrings.locationSuggestionRecurringPartialAvailability
                : owaCalendarStrings.locationSuggestionRecurringAvailability;
            freebusyText = format(
                availabilityStringFormat,
                locationResult.numberOfAvailableTimeSlots,
                locationResult.totalNumberOfTimeSlots
            );
            freebusyStyle = styles.availabilityFree;
        }
    }

    return { freebusyText, freebusyStyle };
}
